import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AlfatekLogo from "@/components/AlfatekLogo";
import { Package, Tag, FolderTree, Users, LayoutGrid, LogOut, ExternalLink, Radar, Inbox, ClipboardList, Settings, Image as ImageIcon } from "lucide-react";

const nav = [
    { to: "/admin", icon: LayoutGrid, label: "Dashboard", end: true, testId: "nav-dashboard" },
    { to: "/admin/produtos", icon: Package, label: "Produtos", testId: "nav-products" },
    { to: "/admin/marcas", icon: Tag, label: "Marcas", testId: "nav-brands" },
    { to: "/admin/categorias", icon: FolderTree, label: "Categorias", testId: "nav-categories" },
    { to: "/admin/banners", icon: ImageIcon, label: "Banners", testId: "nav-banners" },
    { to: "/admin/orcamentos", icon: ClipboardList, label: "Orçamentos", testId: "nav-orcamentos" },
    { to: "/admin/leads", icon: Users, label: "Leads", testId: "nav-leads" },
    { to: "/admin/scrapers", icon: Radar, label: "Scrapers", testId: "nav-scrapers" },
    { to: "/admin/scrapers/curadoria", icon: Inbox, label: "Curadoria", testId: "nav-curadoria" },
    { to: "/admin/configuracoes", icon: Settings, label: "Configurações", testId: "nav-settings" },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const doLogout = async () => {
        await logout();
        navigate("/admin/login", { replace: true });
    };

    return (
        <div className="min-h-screen grid grid-cols-[240px,1fr] bg-[#F4F5F7]">
            <aside className="bg-brand-blue-deep text-white flex flex-col">
                <div className="p-5 border-b border-white/10">
                    <AlfatekLogo className="h-8" />
                    <div className="mt-2 text-[10px] font-mono uppercase tracking-[0.24em] text-brand-yellow">painel admin</div>
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    {nav.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            data-testid={n.testId}
                            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-brand-yellow text-ink font-bold" : "text-neutral-300 hover:bg-white/10 hover:text-white"}`}
                        >
                            <n.icon size={16} />
                            <span>{n.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="p-3 border-t border-white/10 space-y-1">
                    <a href="/" target="_blank" rel="noreferrer" data-testid="link-public-site" className="flex items-center gap-3 px-3 py-2 text-sm text-neutral-300 hover:text-white">
                        <ExternalLink size={14} />
                        <span>Ver site público</span>
                    </a>
                    <div className="px-3 py-2 font-mono text-xs text-neutral-400 truncate">{user?.email}</div>
                    <button data-testid="admin-logout" onClick={doLogout} className="w-full flex items-center gap-3 px-3 py-2 text-sm text-neutral-300 hover:text-white hover:bg-white/10">
                        <LogOut size={14} /> <span>Sair</span>
                    </button>
                </div>
            </aside>
            <main className="min-w-0"><Outlet /></main>
        </div>
    );
}
